/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { SyntheticEvent } from 'react';
import { t } from '../../../../locales/i18n';

import { time2str, timeIsValid, str2time } from '../../../../utils/date-utils';
import { Select, Button, DropdownProps } from 'semantic-ui-react';
import { DatePicker } from '../../../../components/forms/date-picker';
import { BHEntry } from '../../../../types/business-hours';
import {
  QSContainer,
  QSPanelPrimary,
  QSPanelAction,
  QSPanelSecondary
} from './layout-components';

function entryTimeIsValid(val: string | null | undefined) {
  return val && val.trim() !== '' && timeIsValid(val);
}

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

interface RawAddEntryProps {
  onWeekDayChange?: (weekDay: string) => void;
  onChange?: (fieldName: string, value: string) => void;
  entry?: BHEntry;
  disableAdd?: boolean;
  onAdd: (entry: BHEntry) => void;
}

export function RawAddEntry(props: RawAddEntryProps) {
  return (
    <QSContainer>
      <QSPanelPrimary>
        <Select
          value={props.entry ? props.entry.weekDay : 'Mon'}
          onChange={(
            event: SyntheticEvent<HTMLElement>,
            data: DropdownProps
          ) => {
            const val = data.value; //event.target.value; FIXME: zmenil JS
            props.onWeekDayChange && props.onWeekDayChange(val as string);
          }}
          options={days.map((d) => ({
            key: d,
            value: d,
            text: t(`days.${d}`)
          }))}
        />
      </QSPanelPrimary>
      <QSPanelSecondary>
        <DatePicker
          type="time"
          selected={str2time('08:00')}
          onChange={(val) =>
            props.onChange && props.onChange('from', time2str(val))
          }
          value={props.entry ? props.entry.from : ''}
        />
        <DatePicker
          type="time"
          selected={str2time('16:00')}
          onChange={(val) =>
            props.onChange && props.onChange('to', time2str(val))
          }
          value={props.entry ? props.entry.to : ''}
        />
      </QSPanelSecondary>
      <QSPanelAction>
        <Button
          circular
          icon="add"
          basic
          primary
          disabled={props.disableAdd}
          onClick={() => props.entry && props.onAdd(props.entry)}
        />
      </QSPanelAction>
    </QSContainer>
  );
}

export interface AddEntryProps {
  onAdd: (entry: BHEntry) => void;
}

export class AddEntry extends React.Component<AddEntryProps> {
  override state: BHEntry = {
    from: '',
    to: '',
    weekDay: 'Mon'
  };

  handleEntryChange(key: any, val: any) {
    if (!entryTimeIsValid(val)) {
      return false;
    }
    this.setState({ [key]: val });
    return true;
  }

  handleWeekDayChange(val: any) {
    this.setState({ weekDay: val });
  }

  handleEntryAdd(entry: any) {
    this.props.onAdd(entry);
    this.setState({ from: '', to: '' });
  }

  isValid() {
    return entryTimeIsValid(this.state.from) && entryTimeIsValid(this.state.to);
  }

  override render() {
    return (
      <RawAddEntry
        entry={this.state}
        disableAdd={!this.isValid()}
        onWeekDayChange={(val) => this.handleWeekDayChange(val)}
        onChange={(key, val) => this.handleEntryChange(key, val)}
        onAdd={(entry) => this.handleEntryAdd(entry)}
      />
    );
  }
}
